import { type ForwardedRef, forwardRef, type ReactNode } from 'react'

import { copyToClipboard } from '@fv/client-core'
import type { PropsWithClassName } from '@fv/client-types'

import { FvButton } from './FvButton.jsx'
import type { TooltipProps } from './Tooltip.jsx'

type Props = PropsWithClassName<{
  value: string
  tooltipComponent?: (props: TooltipProps) => ReactNode
}>
export const ClipboardButton = forwardRef(
  (
    { value, tooltipComponent, className }: Props,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    if (!value) {
      return null
    }

    const btn = (
      <FvButton
        ref={ref}
        icon="clone"
        transform="shrink-3"
        onClick={() => copyToClipboard(value)}
        className={className}
      />
    )

    if (!tooltipComponent) return btn

    return tooltipComponent({ label: 'Copy', children: btn })
  },
)
